// pages/LoginPage.jsx
// Page de connexion

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { BookOpen } from 'lucide-react';
import RenvoyerConfirmation from '../components/RenvoyerConfirmation';
import './AuthPages.css';
import ChampMotDePasse from '../components/ChampMotDePasse';

export default function LoginPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [nonConfirme, setNonConfirme] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setNonConfirme(false);
    setIsSubmitting(true);

    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message);
      setNonConfirme(err.code === 'EMAIL_NON_CONFIRME');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <BookOpen size={40} color="#4F46E5" />
          <h1>VocaVerb</h1>
          <p>{t('auth.loginSubtitle')}</p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {nonConfirme && <RenvoyerConfirmation email={email} />}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">{t('auth.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('auth.emailPlaceholder')}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('auth.password')}</label>
            <ChampMotDePasse
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('auth.passwordPlaceholder')}
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="auth-submit" disabled={isSubmitting}>
            {isSubmitting ? t('auth.connexion') : t('auth.seConnecter')}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            <Link to="/mot-de-passe-oublie">{t('auth.motDePasseOublie')}</Link>
          </p>
          <p>
            {t('auth.pasDeCompte')} <Link to="/register">{t('auth.creerUnCompte')}</Link>
          </p>
          <p>
            <Link to="/">{t('auth.retourAccueil')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
